/* ObiHub OS — Workspace durum makinesi (SAF).  Router ÇAĞIRMAZ: yalnız `navigationIntent` sonucu üretir.  Storage/tarayıcı API'si KULLANMAZ.
   Kalıcı model yalnız {kind, opaqueId, routeTemplate, params}: başlık ve hassas veri DURUMA GİRMEZ (runtime görünüm modeli ayrıdır: buildViewModel).
   Bilinmeyen eylem ya da bozuk durum fail-closed davranır.  URL/route aktif kayıt için doğruluk kaynağıdır (ROUTE_CHANGED). */
const { buildPath, deepFreeze, matchPath, validateParams } = require("./registry");
const { checkTab } = require("./serializer");

const MAX_CLOSEABLE = 8;
const PHASES = ["active", "logged_out"];
const idOf = (kind, opaqueId) => `${kind}:${opaqueId}`;
const isPlain = (v) => v !== null && typeof v === "object" && !Array.isArray(v);

function createInitialState(registry, { scopePresent = false } = {}) {
  const pinned = registry.entries.filter((e) => e.pinned).map((e) => ({ kind: e.kind, opaqueId: e.pinnedKey, routeTemplate: e.routeTemplate, params: {} }));
  return deepFreeze({
    phase: "active", generation: 1, persistence: scopePresent ? "on" : "off", maxVisible: MAX_CLOSEABLE, pinned, tabs: [],
    activeId: null, dirty: {}, pendingClose: null, last: { ok: true, code: "OK", navigationIntent: null },
  });
}

function isValidState(state, registry) {
  try {
    if (!isPlain(state) || !PHASES.includes(state.phase) || !Number.isInteger(state.generation) || state.generation < 1) return false;
    if (!["on", "off"].includes(state.persistence) || !Number.isInteger(state.maxVisible) || state.maxVisible < 1 || state.maxVisible > MAX_CLOSEABLE) return false;
    if (!Array.isArray(state.tabs) || state.tabs.length > MAX_CLOSEABLE || !Array.isArray(state.pinned) || !isPlain(state.dirty)) return false;
    const expectedPinned = registry.entries.filter((e) => e.pinned).map((e) => idOf(e.kind, e.pinnedKey));
    if (state.pinned.map((t) => idOf(t.kind, t.opaqueId)).join("|") !== expectedPinned.join("|")) return false;
    const ids = new Set();
    for (const t of state.tabs) {
      if (checkTab({ kind: t.kind, opaqueId: t.opaqueId, routeTemplate: t.routeTemplate, params: t.params }, registry) === null) return false;
      const id = idOf(t.kind, t.opaqueId);
      if (ids.has(id)) return false;
      ids.add(id);
    }
    const all = new Set([...ids, ...expectedPinned]);
    if (state.activeId !== null && !all.has(state.activeId)) return false;
    if (Object.keys(state.dirty).some((k) => !ids.has(k) || state.dirty[k] !== true)) return false;
    if (state.pendingClose !== null && !ids.has(state.pendingClose)) return false;
    return true;
  } catch (e) {
    return false;
  }
}

const outcome = (state, code, ok, navigationIntent = null) => ({ state: deepFreeze({ ...state, last: { ok, code, navigationIntent } }), result: { ok, code, navigationIntent } });
const unchanged = (state, code) => outcome(state, code, false);
const navigate = (registry, tab) => ({ type: "navigate", path: buildPath(registry, tab.kind, tab.params) });
const findTab = (state, id) => state.tabs.find((t) => idOf(t.kind, t.opaqueId) === id) || state.pinned.find((t) => idOf(t.kind, t.opaqueId) === id) || null;

function openRecord(state, registry, kind, params, { navigateOnFocus }) {
  const entry = registry.get(kind);
  if (!entry) return unchanged(state, "INVALID_ROUTE");
  if (entry.pinned) {
    const id = idOf(entry.kind, entry.pinnedKey);
    return outcome({ ...state, activeId: id }, "OK", true, navigateOnFocus ? navigate(registry, findTab(state, id)) : null);
  }
  const valid = validateParams(entry, params);
  if (!valid) return unchanged(state, "INVALID_ROUTE");
  const opaqueId = valid[entry.idParam];
  const id = idOf(kind, opaqueId);
  if (state.tabs.some((t) => idOf(t.kind, t.opaqueId) === id)) return outcome({ ...state, activeId: id }, "OK", true, null);   // yinelenen sekme OLUŞMAZ
  if (state.tabs.length >= MAX_CLOSEABLE) return unchanged(state, "TAB_LIMIT_REACHED");                                            // mevcutlar SESSİZCE silinmez
  const tab = { kind, opaqueId, routeTemplate: entry.routeTemplate, params: valid };
  return outcome({ ...state, tabs: [...state.tabs, tab], activeId: id }, "OK", true, null);
}

function closeTab(state, registry, id) {
  const index = state.tabs.findIndex((t) => idOf(t.kind, t.opaqueId) === id);
  const tabs = state.tabs.filter((_, i) => i !== index);
  const { [id]: _removed, ...dirty } = state.dirty;
  let activeId = state.activeId;
  let intent = null;
  if (state.activeId === id) {
    const neighbour = tabs[index - 1] || tabs[index] || state.pinned[0] || null;
    activeId = neighbour ? idOf(neighbour.kind, neighbour.opaqueId) : null;
    intent = neighbour ? navigate(registry, neighbour) : null;
  }
  return outcome({ ...state, tabs, dirty, pendingClose: null, activeId }, "OK", true, intent);
}

const HANDLERS = {
  OPEN_FROM_ROUTE: (s, a, r) => openRecord(s, r, a.kind, a.params, { navigateOnFocus: false }),
  FOCUS_TAB: (s, a, r) => {
    const tab = typeof a.id === "string" ? findTab(s, a.id) : null;
    return tab ? outcome({ ...s, activeId: a.id }, "OK", true, navigate(r, tab)) : unchanged(s, "UNKNOWN_TAB");
  },
  CLOSE_REQUESTED: (s, a, r) => {
    if (typeof a.id === "string" && s.pinned.some((t) => idOf(t.kind, t.opaqueId) === a.id)) return unchanged(s, "PINNED_NOT_CLOSEABLE");
    if (typeof a.id !== "string" || !s.tabs.some((t) => idOf(t.kind, t.opaqueId) === a.id)) return unchanged(s, "UNKNOWN_TAB");
    if (s.dirty[a.id]) return outcome({ ...s, pendingClose: a.id }, "CONFIRMATION_REQUIRED", false);          // kirli sekme DOĞRUDAN kapanmaz
    return closeTab(s, r, a.id);
  },
  CLOSE_CONFIRMED: (s, a, r) => (s.pendingClose ? closeTab(s, r, s.pendingClose) : unchanged(s, "NO_PENDING_CLOSE")),
  CLOSE_CANCELLED: (s) => (s.pendingClose ? outcome({ ...s, pendingClose: null }, "OK", true) : unchanged(s, "NO_PENDING_CLOSE")),
  MARK_DIRTY: (s, a) => (typeof a.id === "string" && s.tabs.some((t) => idOf(t.kind, t.opaqueId) === a.id) ? outcome({ ...s, dirty: { ...s.dirty, [a.id]: true } }, "OK", true) : unchanged(s, "UNKNOWN_TAB")),
  MARK_CLEAN: (s, a) => {
    if (typeof a.id !== "string" || !s.tabs.some((t) => idOf(t.kind, t.opaqueId) === a.id)) return unchanged(s, "UNKNOWN_TAB");
    const { [a.id]: _gone, ...dirty } = s.dirty;
    return outcome({ ...s, dirty }, "OK", true);
  },
  ROUTE_CHANGED: (s, a, r) => {
    const match = matchPath(r, a.pathname);
    if (!match) return outcome({ ...s, activeId: null }, "ROUTE_UNREGISTERED", false);                          // aktif sekme yok; sekmeler SİLİNMEZ
    const res = openRecord(s, r, match.kind, match.params, { navigateOnFocus: false });
    return res;
  },
  RESTORE_VALIDATED: (s, a, r) => {
    if (a.generation !== s.generation) return unchanged(s, "STALE_RESTORE");
    if (s.persistence !== "on") return unchanged(s, "RESTORE_REJECTED");
    if (!Array.isArray(a.tabs)) return unchanged(s, "RESTORE_INVALID");
    const merged = [...s.tabs];
    const seen = new Set(merged.map((t) => idOf(t.kind, t.opaqueId)));
    for (const raw of a.tabs) {
      if (!isPlain(raw)) return unchanged(s, "RESTORE_INVALID");
      const t = checkTab(raw, r);
      if (t === null || t === "pinned") return unchanged(s, "RESTORE_INVALID");                                   // hepsi ya da hiçbiri
      const id = idOf(t.kind, t.opaqueId);
      if (seen.has(id)) {
        if (a.tabs.filter((x) => isPlain(x) && idOf(x.kind, x.opaqueId) === id).length > 1) return unchanged(s, "RESTORE_INVALID");
        continue;
      }
      seen.add(id);
      merged.push(t);
    }
    if (merged.length > MAX_CLOSEABLE) return unchanged(s, "TAB_LIMIT_REACHED");
    return outcome({ ...s, tabs: merged }, "OK", true);
  },
  WORKSPACE_CHANGED: (s, a, r) => {
    if (typeof a.scopePresent !== "boolean") return unchanged(s, "INVALID_ACTION");
    return outcome({ ...createInitialState(r, { scopePresent: a.scopePresent }), generation: s.generation + 1 }, "OK", true);
  },
  LOGOUT: (s, a, r) => outcome({ ...createInitialState(r), phase: "logged_out", generation: s.generation + 1 }, "OK", true),
  // Scope kaybı güvenlik olayıdır: closeable sekmeler, dirty, pendingClose ve aktif kayıt TAMAMEN temizlenir; yalnız pinned başlangıç tanımı kalır.
  SCOPE_LOST: (s, a, r) => outcome({ ...createInitialState(r, { scopePresent: false }), maxVisible: s.maxVisible, generation: s.generation + 1 }, "OK", true),
  SET_CAPACITY: (s, a) => (Number.isInteger(a.maxVisible) && a.maxVisible >= 1 && a.maxVisible <= MAX_CLOSEABLE ? outcome({ ...s, maxVisible: a.maxVisible }, "OK", true) : unchanged(s, "INVALID_ACTION")),
};

function reduce(state, action, registry) {
  if (!isValidState(state, registry)) return outcome(createInitialState(registry), "CORRUPT_STATE", false);        // bozuk durum: güvenli sıfırlama
  if (!isPlain(action) || typeof action.type !== "string" || !Object.prototype.hasOwnProperty.call(HANDLERS, action.type)) return unchanged(state, "UNKNOWN_ACTION");
  if (state.phase !== "active" && action.type !== "WORKSPACE_CHANGED") return unchanged(state, "NOT_ACTIVE");
  try {
    return HANDLERS[action.type](state, action, registry);
  } catch (e) {
    return unchanged(state, "INVALID_ACTION");
  }
}

/** React `useReducer` için: yalnız durumu döndürür (sonuç state.last içinde). */
function createWorkspaceReducer(registry) {
  return (state, action) => reduce(state, action, registry).state;
}

function selectPersistable(state) {
  if (!isPlain(state) || state.phase !== "active" || state.persistence !== "on") return null;
  return { tabs: state.tabs.map((t) => ({ kind: t.kind, opaqueId: t.opaqueId, routeTemplate: t.routeTemplate, params: t.params })) };
}

/** Runtime görünüm modeli: başlıklar YALNIZ burada (çağıranın sağladığı harita), kalıcı duruma girmez. */
function buildViewModel(state, registry, { titles = {} } = {}) {
  const label = (tab) => {
    const given = titles[idOf(tab.kind, tab.opaqueId)];
    return typeof given === "string" && given.trim() !== "" && given.length <= 80 ? given : registry.get(tab.kind).defaultLabel;
  };
  const view = (tab, pinned) => {
    const id = idOf(tab.kind, tab.opaqueId);
    return { id, kind: tab.kind, label: label(tab), pinned, closeable: !pinned, dirty: Boolean(state.dirty[id]), active: state.activeId === id };
  };
  return [...state.pinned.map((t) => view(t, true)), ...state.tabs.map((t) => view(t, false))];
}

/** Taşma düzeni: pinned her zaman görünür; closeable en çok `capacity` kadar görünür, aktif sekme görünür tutulur, sıra korunur. */
function computeLayout(viewModel, capacity) {
  const pinned = viewModel.filter((t) => t.pinned);
  const closeable = viewModel.filter((t) => !t.pinned);
  const cap = Math.max(1, Math.min(MAX_CLOSEABLE, capacity));
  if (closeable.length <= cap) return { visible: [...pinned, ...closeable], overflow: [] };
  const active = closeable.find((t) => t.active);
  let chosen = closeable.slice(0, cap);
  if (active && !chosen.includes(active)) chosen = [...closeable.slice(0, cap - 1), active];
  const set = new Set(chosen);
  return { visible: [...pinned, ...closeable.filter((t) => set.has(t))], overflow: closeable.filter((t) => !set.has(t)) };
}

export { MAX_CLOSEABLE, createInitialState, reduce, createWorkspaceReducer, selectPersistable, buildViewModel, computeLayout, isValidState };
